import _replace from 'lodash/replace'
export const removeAllWS = (str: string) => {
  return _replace(str, / /gi, '')
}
